import React from 'react'
import { useState, useEffect, useRef } from 'react';
import Select, { components } from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';
import * as XLSX from "xlsx";



function AddDataCall() {

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };
  const [selectedTech, setSelectedTech] = useState(null);
  const [user, setUser] = useState([]);
  const [file, setFile] = useState(null);
  const [excelData, setExcelData] = useState([]);

  const options = user.map(t => ({
    value: t.id,
    label: `${t.first} ${t.middle}  ${t.last} - ${t.emp_id}`
  }));


  const handleCancel = () => {
    setFile([]);
  };

  const handleFileUpload = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);

    const reader = new FileReader();

    reader.onload = (evt) => {
      const arrayBuffer = evt.target.result;

      const workbook = XLSX.read(arrayBuffer, { type: "array" });

      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      const data = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
      console.log("Excel data:", data);
      setExcelData(data);
    };

    reader.readAsArrayBuffer(selectedFile);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      if (!excelData || excelData.length === 0) {
        showToast("Please upload and select a valid Excel file", 'danger');
        return;
      }

      const formData = new FormData();

      // formData.append("emp_id", selectedTech.value);
      formData.append('data_type', "pending");

      if (file) {
        formData.append("file", file);
      }


      const response = await axios.post(
        "https://api.skyguard.group/api/upload-bulk-excel-data",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );


      showToast("Data submitted successfully!", 'success');

      // Optional: reset form
      setSelectedTech(null);
      setFile(null);
      setExcelData([]);

      window.location.reload();
    } catch (err) {
      console.error("❌ Error submitting form:", err.response?.data || err.message);
      showToast("Failed to submit data!", 'danger');
    }
  };

  const fectEmphDetail = async () => {
    try {
      const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');
      setUser(resEmployee.data.result);


    } catch (error) {
      console.log(error)
    }
  };


  useEffect(() => {
    fectEmphDetail();
  }, []);

  return (
    <div className='main-section'>
      <ToastNotification
        show={toast.show}
        message={toast.message}
        bg={toast.bg}
        onClose={() => setToast({ ...toast, show: false })}
      />
      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
        <h3 className='my-3 fw-bold fs-5 golos'>Add Data For Call</h3>
        <h2 className="text-center mb-4 fw-bold text-success">
          Add Data
        </h2>
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-6 col-lg-5">
            <div className="card shadow-sm p-4 border-0">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-12 mb-3">
                      <label className="form-label fw-medium">Upload File</label>
                      <input
                        type="file"
                        className="form-control"
                        accept=".xlsx,.xls"
                        onChange={handleFileUpload}
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-center gap-2 mt-3">
                    <button type="submit" className="btn btn-success px-4">
                      Save
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary px-4"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default AddDataCall